import { Button, Group, Modal, Stack, Text, Textarea } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CancelCashupReportModalProps {
  opened: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: (cancellationReason: string | null) => void;
}

export default function CancelCashupReportModal({
  opened,
  isLoading,
  onClose,
  onConfirm
}: CancelCashupReportModalProps) {
  const { t } = useTranslation(['CashupsPage', 'CommonButtons']);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!opened) {
      setReason('');
    }
  }, [opened]);

  const handleConfirm = () => {
    const trimmedReason = reason.trim();
    onConfirm(trimmedReason || null);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('CashupsPage:cancelModal.title')}
      centered>
      <Stack gap="md">
        <Text size="sm">{t('CashupsPage:cancelModal.description')}</Text>
        <Textarea
          label={t('CashupsPage:cancelModal.reasonLabel')}
          value={reason}
          onChange={(event) => setReason(event.currentTarget.value)}
          minRows={3}
          autosize
        />
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={isLoading}>
            {t('CommonButtons:cancel')}
          </Button>
          <Button color="red" onClick={handleConfirm} loading={isLoading} disabled={isLoading}>
            {t('CashupsPage:cancelModal.confirm')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
